import { Trash2 } from 'lucide-react';

import { Button } from '@/components/ui/Button';

interface QueryParamItemProps {
  paramKey: string;
  paramValue: string | number | boolean;
  onDelete: () => void;
}

export function QueryParamItem({
  paramKey,
  paramValue,
  onDelete,
}: QueryParamItemProps) {
  return (
    <div className="to-indigo-50p-1 flex items-center justify-between rounded-lg border border-blue-200 bg-gradient-to-br from-blue-50">
      <div className="flex items-center gap-1 px-4 text-sm">
        <p>{paramKey}</p>
        <span className="text-muted-foreground">:</span>
        <p>{paramValue}</p>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={onDelete}
        className="text-destructive hover:text-destructive"
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
}
